import * as React from 'react';
import TrafficLightTile from './TrafficLightTile';
import GaugeTile from './GaugeTile';
import { StudyModel } from '../Models/StudyModel';
import { studyTypes } from '../Helpers/SharedClasses';
import { ReferenceValuesModel } from '../Models/ReferenceValuesModel';


class TTFMTileHolder extends React.PureComponent<{
    studySelected: StudyModel,
    context: string,
    tileMode : string,
    ACI: number | string,
    MAP: string | number, 
    tilesExpanded: boolean,
    tileClicked: Function,
    mapStale: boolean,
    DiastolicFilling: number | string,
    BackFlow: number | string,
    PulsalityIndex: number | string,
    BeatsPerMinute: number | string, 
    MeanFlow: number | string, 
    usefilling: boolean,
    tileValueChanged: Function,
    overrideName: string,
    ttfmCurves: number,
    indexConfig: ReferenceValuesModel
}> {

    bfGauge: React.RefObject<GaugeTile>;
    mfGauge: React.RefObject<GaugeTile>;
    piGauge: React.RefObject<GaugeTile>;
    dfGauge: React.RefObject<GaugeTile>;
    constructor(props: any) {
        super(props);
        this.bfGauge = React.createRef();
        this.mfGauge = React.createRef();
        this.dfGauge = React.createRef();
        this.piGauge = React.createRef();
        this.state = { 
            comparisonSelected: false,
            selectedIndex: 0
        }
    }

    componentDidMount(){

    }

    static defaultProps = {
    tilesExpanded: false,
    mapStale: false,
    overrideName: "",
    ttfmCurves: 1,
    tileClicked: ()=>
    {

    },
    
    tileValueChanged: ()=>
    {
        
    }

    }
    getTileVisibility = () => {
        const { studySelected } = this.props;
        return {
            showCardiacTiles: !studySelected.studyType || 
                      studySelected.studyType === studyTypes.None || 
                      studySelected.studyType === studyTypes.Cardiac,
            // add more visibility flags here as needed
            // Example: showVascular: studySelected.studyType === studyTypes.Vascular
        };
    }

    performResize = () => {

    
    if (this.props.tileMode === "Gauges") {

        let bfGauge = this.bfGauge.current as GaugeTile;
        if (bfGauge) 
            bfGauge.resizeGauge();
        let dfGauge = this.dfGauge.current as GaugeTile;
        if (dfGauge) 
            dfGauge.resizeGauge();
        let mfGauge = this.mfGauge.current as GaugeTile;
        if (mfGauge) 
            mfGauge.resizeGauge();
        let piGauge = this.piGauge.current as GaugeTile;
        if (piGauge) 
            piGauge.resizeGauge();

        }
        this.refreshAllTiles();

    }

    refreshAllTiles = () =>
    {
        if (this.bfGauge.current as GaugeTile)
            (this.bfGauge.current as GaugeTile).drawReferenceValuesGauge();
            if (this.mfGauge.current as GaugeTile)
            (this.mfGauge.current as GaugeTile).drawReferenceValuesGauge();
            if (this.piGauge.current as GaugeTile)
            (this.piGauge.current as GaugeTile).drawReferenceValuesGauge();
            if (this.dfGauge.current as GaugeTile)
            (this.dfGauge.current as GaugeTile).drawReferenceValuesGauge();


    }

    calculateGaugeRanges(min?:number, max?:number, defaultMin = 0, defaultMax = 100) {
        const actualMin = min ?? defaultMin;
        const actualMax = max ?? defaultMax;
        
        const isRangeWideEnoughForGaps = (actualMax - actualMin) >= 2;
        const diff = actualMax > actualMin ? actualMax - actualMin : defaultMax;

        
        let calculatedBadRange;

        //gap the ranges for general useses to avoid overlapping zones
        if (isRangeWideEnoughForGaps) {
            calculatedBadRange = {
                min: actualMin + 1,
                max: actualMax 
            };
        } else {
            // Fallback for too narrow ranges
            calculatedBadRange = {
                min: actualMin,
                max: actualMax
            };
        }
    
        return {
          goodRange: { 
            min: Math.max(0, actualMin - diff), 
            max: actualMin 
          },
          badRange: calculatedBadRange,
          worstRange: { 
            min: actualMax+1, 
            max: actualMax + diff 
          }
        };
      }

    render() {
    // The calls are now much cleaner and more readable.
    // Your calculateGaugeRanges function handles any undefined values gracefully.
    const meanTileLimits = this.calculateGaugeRanges(this.props.indexConfig.meanLowerReferenceValue, this.props.indexConfig.meanUpperReferenceValue);
    const piTileLimits = this.calculateGaugeRanges(this.props.indexConfig.piLowerReferenceValue, this.props.indexConfig.piUpperReferenceValue);
    const dfTileLimits = this.calculateGaugeRanges(this.props.indexConfig.dfLowerReferenceValue, this.props.indexConfig.dfUpperReferenceValue);
    const bfTileLimits = this.calculateGaugeRanges(this.props.indexConfig.bfLowerReferenceValue, this.props.indexConfig.bfUpperReferenceValue);
    const aciTileLimits = this.calculateGaugeRanges(this.props.indexConfig.aciLowerReferenceValue, this.props.indexConfig.aciUpperReferenceValue);
    let tileHolder: React.ReactElement;
    const { showCardiacTiles } = this.getTileVisibility();
    let showMAP = (this.props.MAP &&  showCardiacTiles) || (this.props.MAP && this.props.MAP!=="--" && !showCardiacTiles);
    if (this.props.tileMode === "Tiles")
    {
        tileHolder = <>
        <TrafficLightTile
                            context={this.props.context}
                            key="ACI"
                            value={  typeof this.props.ACI !== "number" ? "--" : Math.round(this.props.ACI as number)}
                            title="ACI"
                            uom="%"
                            enableColouring={true}
                            goodColor={this.props.indexConfig.aciGoodColor}
                            badColor={this.props.indexConfig.aciBadColor}
                            worstColor={this.props.indexConfig.aciWorstColor}
                            {...aciTileLimits} tileClicked={this.props.tileClicked} expanded={this.props.tilesExpanded}></TrafficLightTile> 
                        {
                          showMAP  ? 
                        <TrafficLightTile
                        context={this.props.context}
                    key="MAP"
                    enableColouring={true}
                    value={this.props.MAP as number}
                    valueStale={this.props.mapStale}
                    title={showCardiacTiles? "MAP" : "SYS"}
                    uom="mm Hg"
                    defaultColor="tile-no-data"
                    wideTile={true}
                
                    goodRange={{
                    min: 60,
                    max: 200
                }}
                    badRange={{
                    min: 0,
                    max: 60
                }}
                    worstRange={{
                    min: 0,
                    max: 0
                }}
                    includeEdit={false}
                    tileValueChanged={this.props.tileValueChanged}
                    tileClicked={this.props.tileClicked}
                    expanded={this.props.tilesExpanded}></TrafficLightTile> :<></>
            }
                    <TrafficLightTile
                    enableColouring={true}
                    context={this.props.context}
                key = "MeanFlow"
                value = {
                    typeof this.props.MeanFlow !== "number"  ? "--" : Math.round(this.props.MeanFlow as number)
                }
                title = "MF"
                uom = "mL/min"
                goodColor={this.props.indexConfig.meanGoodColor}
                badColor={this.props.indexConfig.meanBadColor}
                worstColor={this.props.indexConfig.meanWorstColor}
                {...meanTileLimits}  tileClicked={this.props.tileClicked}
                wideTile = {true}
                expanded = {
                    this.props.tilesExpanded
                } ></TrafficLightTile> <TrafficLightTile
                context={this.props.context}
                key = "PulsalityIndex"
                value = {
                    typeof this.props.PulsalityIndex !== "number"  ? "--" : (this
                        .props
                        .PulsalityIndex as number)
                        .toFixed(1) as any
                }
                title = "PI"
                uom = ""
                maxValue = {
                    99
                }
                enableColouring={true}
                 goodColor={this.props.indexConfig.piGoodColor}
                badColor={this.props.indexConfig.piBadColor}
                worstColor={this.props.indexConfig.piWorstColor}
                {...piTileLimits}
                tileClicked = {
                    this.props.tileClicked
                }
                expanded = {
                    this.props.tilesExpanded
                } ></TrafficLightTile> 
                {(showCardiacTiles && typeof this.props.DiastolicFilling === "number") && (
                    <TrafficLightTile
                    context={this.props.context}
                    key = "DiastolicFilling"
                    value = {
                        typeof this.props.DiastolicFilling !== "number"  ? "--" : Math.round(this.props.DiastolicFilling as number)
                    }
                    enableColouring={true}
                        goodColor={this.props.indexConfig.dfGoodColor}
                badColor={this.props.indexConfig.dfBadColor}
                worstColor={this.props.indexConfig.dfWorstColor}
                {...dfTileLimits}
                    title = "DF"
                    uom = "%"
                    includeSubValue = {
                        true
                    }
                    subValue = {
                        typeof this.props.BeatsPerMinute !== "number" ? "--" : Math.round(this.props.BeatsPerMinute as number) as any
                    
                    }
                    subValueUom = "BPM" tileClicked = {
                        this.props.tileClicked
                    }
                    expanded = {
                        this.props.tilesExpanded
                    } ></TrafficLightTile> )}
            
            
        
            </>
        
        
    }else 
    {
    tileHolder =  <>
    <div className="left-tiles-container">
    <TrafficLightTile
    context={this.props.context}
                        key="ACI"
                        value={  typeof this.props.ACI !== "number" ? "--" : Math.round(this.props.ACI as number)}
                        title="ACI"
                        uom="%"
                        referenceValueStyle="Stacked"
                        enableColouring={true}
                        goodColor={this.props.indexConfig.aciGoodColor}
                        badColor={this.props.indexConfig.aciBadColor}
                        worstColor={this.props.indexConfig.aciWorstColor}
                        // {...this.context.tileLimits.ACI}
                         {...aciTileLimits}
                        
                    tileClicked={this.props.tileClicked} expanded={this.props.tilesExpanded}></TrafficLightTile >
                    
                    {showMAP  ? 
                     <TrafficLightTile
                    key="MAP"
                    value={this.props.MAP as any}
                    valueStale={this.props.mapStale}
                    referenceValueStyle="Stacked"
                    title={showCardiacTiles ? "MAP" : "SYS"}
                    uom="mm Hg"
                    defaultColor="tile-no-data"
                    wideTile={true}
                    enableColouring={true}
                    // {...this.context.tileLimits.MAP}
                    goodRange={{
                    min: 60,
                    max: 200
                }}
                    badRange={{
                    min: 0,
                    max: 60
                }}
                    worstRange={{
                    min: 0,
                    max: 0
                }}
                    includeEdit={false}
                    tileValueChanged={this.props.tileValueChanged}
                    tileClicked={this.props.tileClicked}
                    expanded={this.props.tilesExpanded}></TrafficLightTile>: <></>}
                     </div>
                
                
                    <GaugeTile
                    overridename={this.props.overrideName}
                    sizeFactor={this.props.ttfmCurves}
                    includeEdit={false}
                    onConfigChanged={(newConfig) => {
                        // Save new configuration
                        console.log('New configuration:', newConfig);
                        // Update your state/backend with new ranges
                      }}
                    context={this.props.context}
                    ref={this.mfGauge}
                    goodColor={this.props.indexConfig.meanGoodColor || "var(--newDolphin)" }
                    badColor={this.props.indexConfig.meanBadColor|| "var(--newDolphin)"}
                    worstColor={this.props.indexConfig.meanWorstColor|| "var(--newDolphin)"}

                    key="MeanFlow"
                        value={typeof this.props.MeanFlow === 'number' ? Math.round(this.props.MeanFlow) : undefined}
                        title="MF"
                        uom="mL/min "
                    
                        {...meanTileLimits}
            loadableRefValueMode={true}
                    tileClicked = {
                    this.props.tileClicked
                }
                expanded = {
                    this.props.tilesExpanded
                } />
                

                <GaugeTile
                overridename={this.props.overrideName}
                sizeFactor={this.props.ttfmCurves}
                context={this.props.context}
                ref = {this.piGauge}
                key = "PulsalityIndex"
                defaultColor = "tile-redlight"
                includeEdit={false}
                onConfigChanged={(newConfig) => {
                    // Save new configuration
                    console.log('New configuration:', newConfig);
                    // Update your state/backend with new ranges
                }}
                value={typeof this.props.PulsalityIndex === 'number' ? this.props.PulsalityIndex : undefined}
                goodColor={this.props.indexConfig.piGoodColor|| "var(--newDolphin)"}
                badColor={this.props.indexConfig.piBadColor|| "var(--newDolphin)"}
                worstColor={this.props.indexConfig.piWorstColor|| "var(--newDolphin)"}
                title = "PI"
                uom = ""
                maxValue = {
                    99
                }
                reverseValues = {
                    false
                }
                {...piTileLimits}
              loadableRefValueMode={true}
                    tileClicked = {
                    this.props.tileClicked
                }
                expanded = {
                    this.props.tilesExpanded
                } /> 
                {showCardiacTiles && (
                    <>
                    <GaugeTile
                        overridename={this.props.overrideName}
                        sizeFactor={this.props.ttfmCurves}
                        context={this.props.context}
                        ref = {this.dfGauge}
                        key = "DiastolicFilling"
                        
                        value={this.props.usefilling && typeof this.props.DiastolicFilling === 'number' ? Math.round(this.props.DiastolicFilling) : undefined}
                        subValue={typeof this.props.BeatsPerMinute === 'number' ? Math.round(this.props.BeatsPerMinute) : undefined}
    
                        title = "DF"
                        uom = "%"
                        defaultColor = "tile-yellowlight"
                        includeSubValue = {
                            true
                        }
                        reverseValues = {
                            false
                        }
                        goodColor={this.props.indexConfig.dfGoodColor|| "var(--newDolphin)"}
                        badColor={this.props.indexConfig.dfBadColor|| "var(--newDolphin)"}
                        worstColor={this.props.indexConfig.dfWorstColor|| "var(--newDolphin)"}
                        {...dfTileLimits}

                        loadableRefValueMode={true}
                        subValueUom = "BPM" tileClicked = {
                            this.props.tileClicked
                        }
                        expanded = {
                            this.props.tilesExpanded
                        } 
                    /> 
                    <GaugeTile
                        overridename={this.props.overrideName}
                        sizeFactor={this.props.ttfmCurves}
                    context={this.props.context}
                    ref = {this.bfGauge}
                    key = "BackFlow"
                    value={typeof this.props.BackFlow === 'number' ? Math.round(this.props.BackFlow) : undefined}

                    defaultColor = "tile-redlight"
                    
                    title = "BF"
                    uom = "%"
                    reverseValues = {
                        false
                    }
                    {...bfTileLimits}
                    loadableRefValueMode={true}
                    goodColor={this.props.indexConfig.bfGoodColor|| "var(--newDolphin)"}
                    badColor={this.props.indexConfig.bfBadColor|| "var(--newDolphin)"}
                    worstColor={this.props.indexConfig.bfWorstColor|| "var(--newDolphin)"}
                        tileClicked = {
                        this.props.tileClicked
                    }
                    expanded = {
                        this.props.tilesExpanded
                    } /> 
                </>
            )}
        
            </>;


            }
    return   <div className={"tile-container "  + (this.props.tileMode === "Gauges" ? " gauge-mode": " tile-mode") + (showCardiacTiles ? " cardiac" : " vascular") } >{tileHolder}</div>;
    }
}

export default TTFMTileHolder;


